import { environment } from './environment';

/**
 * API origin (scheme + host, no trailing /api) for full-page redirects (e.g. Apple Sign In).
 * HttpClient requests use UrlInterceptor; window.location does not — this must mirror that logic.
 */
export function getOAuthApiOrigin(): string {
  let protocol = environment.apiProtocol;
  let baseAddress = environment.apiBaseAddress;
  if (!environment.production) {
    protocol = environment.local_apiProtocol || environment.apiProtocol;
    baseAddress = environment.local_apiBaseAddress || environment.apiBaseAddress;
  }
  return `${protocol}${baseAddress}`.replace(/\/api\/?$/, '');
}
